<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Services</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Services</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="card">
        <div class="overlay" v-if="is_loading">
          <img src="/assets/images/loader.svg" alt="" />
        </div>
        <div class="card-header">
          <h3 class="card-title">Detail</h3>
          <div class="card-tools">
            <router-link class="btn btn-info" :to="{ name: 'Services' }">
              <i class="fas fa-list"></i> List
            </router-link>
          </div>
        </div>
        <div class="card-body table-responsive p-0">
          <table class="table table-striped">
            <tbody>
              <tr>
                <td><b>Name</b></td>
                <td>{{ item.name }}</td>
              </tr>
              <tr>
                <td><b>Display Name</b></td>
                <td>{{ item.display_name }}</td>
              </tr>
              <tr>
                <td><b>Is Wallet</b></td>
                <td>{{ item.is_wallet ? "Yes" : "No" }}</td>
              </tr>
              <tr>
                <td><b>Service Logo</b></td>
                <td>
                  <img
                    v-if="item.service_logo"
                    v-bind:src="service_logo"
                    alt="service_logo"
                    class="img-thumbnail"
                  />
                </td>
              </tr>
              <tr>
                <td><b>Created At</b></td>
                <td>
                  {{ !_.isEmpty(item.created_at) ? item.created_at : "" }}
                </td>
              </tr>
              <tr>
                <td><b>Updated At</b></td>
                <td>
                  {{ !_.isEmpty(item.updated_at) ? item.updated_at : "" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer"></div>
      </div>
    </section>
  </div>
</template>

<script>
import { ServicesAPI } from "@/services/api";

export default {
  name: "ServiceShow",
  metaInfo: {
    title: "Service Detail | Dotlines",
  },
  data: () => ({
    item: {},
    is_loading: false,
    service_logo: "",
  }),
  mounted: function () {
    this.serviceShow(this.$route.params.id);
  },
  methods: {
    serviceShow(id) {
      ServicesAPI.show(id).then((result) => {
        this.item = result;
        this.asset_get_url = process.env.VUE_APP_ASSET_UPLOAD_URL;
        this.service_logo = this.asset_get_url + "/" + this.item.service_logo;
      });
    },
  },
};
</script>
